// plataforma.ts
// ───────────────────────────────────────────────────────────────────────────
// ¿Este navegador ve las passkeys de iCloud Keychain sin que se las activemos?
//
// Una passkey creada en un dispositivo Apple viaja por iCloud a todos los
// demás (Mac, iPhone, iPad). Safari (y los navegadores de iOS/iPadOS, que
// usan el motor de Safari) las ve, así que la biometría del segundo factor
// funciona ahí desde la primera vez. Chrome, Edge y Firefox de escritorio NO:
// cada uno guarda las suyas y, si no hay ninguna, abren el QR del celular.
//
// Esto es una pista para decidir si se dispara la biometría sola; no se usa
// para nada de seguridad. Si falla (una cuenta sin passkey de iCloud), el
// segundo factor cae al código TOTP como siempre.
// ───────────────────────────────────────────────────────────────────────────

export function vePasskeysDeIcloud(
  ua: string = globalThis.navigator?.userAgent ?? '',
  puntosDeToque: number = globalThis.navigator?.maxTouchPoints ?? 0,
): boolean {
  // iPhone y iPad: todos los navegadores usan WebKit y la llave de iCloud.
  if (/iPhone|iPad|iPod/.test(ua)) return true;
  // iPadOS pide «sitio de escritorio» y se presenta como Mac, pero tiene pantalla táctil.
  if (/Macintosh/.test(ua) && puntosDeToque > 1) return true;
  // Safari de escritorio: dice «Safari» y ninguno de los motores de Chromium o Firefox.
  const esSafari = /Safari\//.test(ua) && !/Chrome\/|Chromium\/|Edg(e|A|iOS)?\/|OPR\/|Firefox\//.test(ua);
  return esSafari && /Macintosh/.test(ua);
}
